import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { sendEvent } from '@spa/shared/clients/dataEvents';
import { useAuth } from '@spa/shared/hooks/auth';

const OFFER_VIEW = 'offer-view';

const SEARCH_KEY = 'search-id';

export const getSearchId = location => {
  if (!location || !location.hash || !location.hash.includes(SEARCH_KEY)) {
    return null;
  }

  const hashes = location.hash.split('#');
  const searchKey = hashes.find(element => element.includes(SEARCH_KEY));
  const [, searchId] = searchKey.split(`${SEARCH_KEY}=`) ?? [null, null];

  return searchId;
};

export const useStreams = (offers, referrer = '', isCrawler = false) => {
  const { query, asPath } = useRouter();

  const { profile, isLoadingProfile } = useAuth();
  const [, queryString = ''] = asPath.split('?');

  const handleOfferViewTracking = () => {
    if (isLoadingProfile || !window.location) {
      return null;
    }

    const searchId = getSearchId(window.location) || query[SEARCH_KEY] || null;
    const [, tracking] = searchId ? searchId.split('_') : [null, ''];

    Promise.all(
      isCrawler
        ? [Promise.resolve()]
        : offers.map(({ accommodation_offer: { id } }) =>
            sendEvent(OFFER_VIEW, {
              view_id: searchId,
              event_name: 'guest_view_offer',
              offer_id: id,
              guest_id: profile ? profile.id : null,
              referrer,
              tracking_id: tracking,
              query_string: queryString,
              created_at: Date.now()
            })
          )
    );
  };

  useEffect(() => {
    handleOfferViewTracking();
  }, [isLoadingProfile]);
};
